<template>
    <div class="dinnercard">
        <van-nav-bar
            title="套餐卡"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-loading vertical v-if="loading"/>
        <van-notice-bar :scrollable="false" color="black" background="#f2f2f2">
            {{shopName}}
        </van-notice-bar>
        <van-tabs color="#0099FF" title-active-color="#0099FF">
            <van-tab title="可用">
                <package-item v-for="item in availableCardList" :key="item.id" :id="item.id" :title="item.package_name?(item.package_name+'/'+item.number):item.number" :begindate="item.begin_date" :enddate="item.end_date" :state="item.status" />
            </van-tab>
            <van-tab title="不可用">
                <package-item v-for="item in unAvailableCardList" :key="item.id" :id="item.id"  :title="item.package_name?(item.package_name+'/'+item.number):item.number" :begindate="item.begin_date" :enddate="item.end_date" :state="item.status" />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { NavBar,Tabs, Tab, Cell, CellGroup, Loading, NoticeBar, Toast } from 'vant';
import { UserCardApi } from '@/api/vip'
import { toErrorPage } from '@/utils/usePage'
import PackageItem from '@/view/components/packageitem'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Loading.name]: Loading,
        [NoticeBar.name]: NoticeBar,
        [Toast.name]: Toast,
        PackageItem
    },
    data() {
        return {
            availableCardList: [],//可用
            unAvailableCardList: [],//不可用
            shopName:'',
            loading: true
        }
    },
    mounted(){
        this.getCard()
    },
    methods: {
        getCard(){
            var that = this
            that.axios.get(UserCardApi).then((ret) => {
                this.loading = false
                if (ret.flag) {
                    if (ret.details.length > 0) {
                        let it = ret.details[0]
                        that.shopName = it.shop_name
                        it.card.forEach(item => {
                            if (item.type == 0) {
                                if(item.status===1)
                                    that.availableCardList.push(item)
                                else{
                                    // item['statusName'] = (item.status===2?'已用完':'已过期')
                                    that.unAvailableCardList.push(item)
                                    console.log(that.unAvailableCardList)
                                }
                            }
                        })
                    }
                } else {
                    toErrorPage(that,'',ret.info,null)
                }
                
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.dinnercard {
    .van-tabs {
        background-color: #F5F5F5;

        .van-tabs--line {
            .van-hairline--top-bottom {
                color: #DDDDDD;

                .van-tab--active {
                    color: black;
                }
            }
        }
    }
}
</style>